import type { FormatterArgs } from '@/services/types/formatter';

const ICON_PATTERNS = [
  { search: 'fa fa-bank', icon: 'fa fa-university', replace: '<i class="fa fa-bank"></i>' },
  { search: 'fa fa-sitemap', icon: 'fas fa-sitemap', replace: '<i class="fa fa-sitemap"></i>' },
  { search: 'fa fa-briefcase', icon: 'fas fa-briefcase', replace: '<i class="fa fa-briefcase"></i>' },
  { search: 'fa fa-globe', icon: 'fas fa-globe', replace: '<i class="fa fa-globe"></i>' },
  { search: 'fa fa-laptop', icon: 'fas fa-laptop', replace: '<i class="fa fa-laptop"></i>' },
  { search: 'fa fa-internet-explorer', icon: 'fab fa-internet-explorer', replace: '<i class="fa fa-internet-explorer"></i>' },
  { search: 'fa fa-wifi', icon: 'fas fa-wifi', replace: '<i class="fa fa-wifi"></i>' },
  { search: 'fa fa-windows', icon: 'fab fa-windows', replace: '<i class="fa fa-windows"></i>' },
  { search: 'fa fa-code', icon: 'fas fa-code', replace: '<i class="fa fa-code"></i>' },
  { search: 'fa fa-external-link', icon: 'fas fa-external-link-alt', replace: '<i class="fa fa-external-link"></i>' },
] as const;

export default ({ data, key }: FormatterArgs) => {
  const cellValue = String(data[key] ?? '');

  if (cellValue === 'Empty') {
    return { kind: 'class-name', text: 'Empty' };
  }

  const pattern = ICON_PATTERNS.find((item) => cellValue.includes(item.search));
  if (!pattern) return;

  return {
    kind: 'icon-text',
    icon: pattern.icon,
    text: cellValue.replace(pattern.replace, ' '),
    iconColor: 'var(--color-gray50)',
  };
};
